/**
 * @desc 在后台管理系统中修改会员的保证金比例
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateOperationMemberDepositValueParameter = {
  memberId?: string

  depositValue?: number
}

const method = 'PUT'
const url = '/auth/operation/member/member/depositValue'

export const updateOperationMemberDepositValueApi = (
  params?: UpdateOperationMemberDepositValueParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

updateOperationMemberDepositValueApi.method = method
updateOperationMemberDepositValueApi.url = url
